var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    d: "M0 0L0 1024L1024 1024L1024 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M288 134L289 135L288 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3db521",
      stroke: "none"
    },
    d: "M270 566L185 566C192.057 578.208 205.08 588.08 215 598C233.167 616.167 250.821 634.82 269 653C323.321 707.324 375.802 763.556 430.001 818C447.468 835.546 464.509 853.509 482 871C492.607 881.607 500.907 891.227 517 889.907C529.835 888.854 538.579 877.421 547 869C565.843 850.157 584.151 830.849 603 812C657.296 757.704 710.974 702.495 764.039 647C780.777 629.496 797.902 612.126 815 595C824.278 585.707 835.433 576.742 843 566L757 566C768.747 554.252 780.684 542.318 791.83 530C796.496 524.844 802.421 515.155 809.039 512.603C814.855 510.361 823.822 512 830 512L872 512C878.19 512 885.956 513.257 891.961 511.682C899.767 509.635 906.858 495.484 910.797 489C924.751 466.032 935.989 441.55 941.196 415C949.096 374.72 948.295 330.146 934.921 291C894.061 171.394 763.796 105.193 644 146.003C617.325 155.09 593.067 170.3 572 188.845C558.824 200.443 547.39 213.61 535 226C528.386 232.614 518.985 239.455 515 248C490.904 231.026 472.325 204.706 450 185.289C414.748 154.63 371.08 138.555 325 134.17C237.299 125.823 147.735 178.505 107.363 256C75.7797 316.624 72.4973 394.076 99.4275 457C105.716 471.694 113.875 486.148 123.377 499C126.257 502.895 129.652 509.431 134.289 511.397C139.342 513.538 147.576 512 153 512L198 512C203.851 512 212.416 510.429 217.91 512.603C223.928 514.985 228.593 523.467 233.015 528C245.361 540.658 257.485 553.485 270 566z"
  }), " -->\n", /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M327 134L328 135L327 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M699 134L700 135L699 134M739 134L740 135L739 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M343 136L344 137L343 136M761 137L762 138L761 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M354 138L355 139L354 138M363 140L364 141L363 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M232 146L233 147L232 146M383 146L384 147L383 146M795 146L796 147L795 146M393 150L394 151L393 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M820 157L821 158L820 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M415 161L416 162L415 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M831 163L832 164L831 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M834 165L835 166L834 165M597 169L598 170L597 169M840 169L841 170L840 169M587 176L588 177L587 176M578 183L579 184L578 183M166 186L167 187L166 186M461 196L462 197L461 196M547 213L548 214L547 213M546 214L547 215L546 214M545 215L546 216L545 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285d95",
      stroke: "none"
    },
    d: "M340 225L341 226L340 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285d95",
      stroke: "none"
    },
    d: "M515 583C524.707 571.284 530.435 553.625 537.247 540L582.247 450C589.604 435.285 597.381 407.6 616 404.329C635.123 400.969 643.768 415.044 651.247 430C660.618 448.74 670.136 467.39 679.742 486C683.542 493.364 686.515 503.422 691.966 509.682C697.406 515.929 721.054 512 729 512L784 512C790.035 512 800.445 513.986 805.826 510.972C813.34 506.765 819.196 493.382 823.11 486C872.716 392.443 822.699 265.671 722 232.519C647.075 207.853 558.727 243.506 514 307C496.182 289.182 478.797 270.616 458 256.205C425.559 233.727 382.516 221.409 343 225.17C324.677 226.913 306.81 230.612 290 238.309C191.583 283.372 154.35 409.817 212.436 501C223.231 517.946 246.808 512 265 512L294 512C297.278 512 302.524 512.964 305.362 510.972C311.905 506.381 315.515 489.294 318.576 482C329.478 456.02 340.109 429.922 351.15 404C359.795 383.702 366.332 348.704 394 350.04C419.31 351.262 427.733 386.85 436 406C461.559 465.203 487.388 524.727 515 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M122 232L123 233L122 232M618 232L619 233L618 232M615 233L616 234L615 233M435 243L436 244L435 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M514 247L515 248L514 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M111 249L112 250L111 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M576 251L577 252L576 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M261 254L262 255L261 254M571 254L572 255L571 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M767 256L768 257L767 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M105 260L106 261L105 260M252 261L253 262L252 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M776 263L777 264L776 263M245 267L246 268L245 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M928 274L929 275L928 274M482 276L483 277L482 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M220 294L221 295L220 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M812 303L813 304L812 303M208 312L209 313L208 312M822 320L823 321L822 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M829 336L830 337L829 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M944 337L945 338L944 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M837 363L838 364L837 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M423 377L424 378L423 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M354 395L355 396L354 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M943 401L944 402L943 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M614 404L615 405L614 404M634 406L635 407L634 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M603 410L604 411L603 410M841 417L842 418L841 417M444 424L445 425L444 424M89 427L90 428L89 427M936 432L937 433L936 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M448 433L449 434L448 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M187 437L188 438L187 437M452 442L453 443L452 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285d95",
      stroke: "none"
    },
    d: "M393 447C383.016 476.511 369.06 505.333 356.85 534C353.577 541.686 349.75 560.366 342.606 564.972C337.91 568.001 327.434 566 322 566L271 566C285.016 585.898 306.306 602.175 322.91 620C362.858 662.884 403.565 705.549 445 747C465.186 767.194 485.37 799.914 517 798.985C531.795 798.55 542.76 787.015 552.089 777C562.159 766.19 572.627 755.502 583.004 745C619.796 707.765 655.472 669.46 692.015 632C712.649 610.848 737.978 590.164 755 566L686 566L659.39 564.972L647.753 544L622 493C611.858 505.24 605.871 523.764 598.753 538C584.387 566.733 569.617 595.259 555.247 624C548.064 638.365 540.47 664.663 525 671.811C495.73 685.334 485.423 648.281 476.255 629C447.961 569.495 418.829 508.418 395 447L393 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M331 450L332 451L331 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M397 453L398 454L397 453M191 455L192 456L191 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M389 456L390 457L389 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M460 460L461 461L460 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M825 480L826 481L825 480M677 481L678 482L677 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M113 483L114 484L113 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M678 483L679 484L678 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M376 487L377 488L376 487M680 487L681 488L680 487M681 489L682 490L681 489M414 491L415 492L414 491M815 498L816 499L815 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M896 508L897 509L896 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M132 510L133 511L132 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M366 511L367 512L366 511M485 516L486 517L485 516M242 537L243 538L242 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M592 550L593 551L592 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M348 554L349 555L348 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M184 566L185 567L184 566M185 567L186 568L185 567M186 568L187 569L186 568M743 578L744 579L743 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M457 587L458 588L457 587M297 593L298 594L297 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81ff01",
      stroke: "none"
    },
    d: "M807 602L808 603L807 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M715 607L716 608L715 607M231 614L232 615L231 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M325 622L326 623L325 622M474 625L475 626L474 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M687 636L688 637L687 636M544 645L545 646L544 645M351 649L352 650L351 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M760 650L761 651L760 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M487 654L488 655L487 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M278 662L279 663L278 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M495 667L496 668L495 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M526 671L527 672L526 671M506 673L507 674L506 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M379 678L380 679L379 678M712 699L713 700L712 699M711 700L712 701L711 700M407 707L408 708L407 707M328 713L329 714L328 713M435 736L436 737L435 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M664 748L665 749L664 748M577 750L578 751L577 750z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81ff01",
      stroke: "none"
    },
    d: "M373 759L374 760L373 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21df1e",
      stroke: "none"
    },
    d: "M549 779L550 780L549 779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ab617",
      stroke: "none"
    },
    d: "M531 794L532 795L531 794M617 796L618 797L617 796M616 797L617 798L616 797M615 798L616 799L615 798M422 809L423 810L422 809M570 844L571 845L570 844M468 856L469 857L468 856z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.3a314c30a3303ced8ee7b58b59891ef9.svg";
export { ForwardRef as ReactComponent };